import { useState, useCallback, useRef } from 'react'

interface UseClipboardResult {
  copy: (text: string) => Promise<void>
  copied: boolean
}

export function useClipboard(): UseClipboardResult {
  const [copied, setCopied] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const copy = useCallback(async (text: string): Promise<void> => {
    await navigator.clipboard.writeText(text)

    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    setCopied(true)
    timerRef.current = setTimeout(() => {
      setCopied(false)
    }, 2000)
  }, [])

  return { copy, copied }
}
